import { css } from '@emotion/react';
import { OnlineStatus } from 'graphql/types';
import colors from 'lib/colors';
import { useTranslation } from 'react-i18next';

interface Props {
  status: OnlineStatus;
}

const StatusBadge = ({ status }: Props) => {
  const [t] = useTranslation();
  return (
    <span
      css={css`
        display: flex;
        height: fit-content;
        align-self: center;
        vertical-align: middle;
        background-color: ${badgeColors[status]};
        border-radius: 8px;
        padding: 3px 4px;
        margin-left: 8px;
        color: white;
        text-transform: uppercase;
        font-size: 0.4375rem;
        line-height: 1.15;
        font-weight: bold;
      `}
    >
      {t(...statusTexts[status])}
    </span>
  );
};
export default StatusBadge;

const badgeColors = {
  [OnlineStatus.ONLINE]: colors.success,
  [OnlineStatus.OFFLINE]: colors.danger,
  [OnlineStatus.INGAME]: colors.primary,
};

const statusTexts = {
  [OnlineStatus.ONLINE]: ['lobby.game.status.online', 'online'] as [
    string,
    string,
  ],
  [OnlineStatus.OFFLINE]: ['lobby.game.status.offline', 'offline'] as [
    string,
    string,
  ],
  [OnlineStatus.INGAME]: ['lobby.game.status.ingame', 'hraje'] as [
    string,
    string,
  ],
};
